import * as Yup from 'yup';

export const GroupFormValidationSchema = Yup.object().shape({
  name: Yup.string(),
  description: Yup.string(),
  is_private: Yup.bool().oneOf([false, true]).required('errors.required'),
});
